import createAxios from './api'

const PATH = 'signatures'

export default {
  async sign(req, timeOut) {
    const axios = await createAxios(true, timeOut)
    const resp = await axios.post(`${PATH}/sign`, { ...req })

    return resp.data
  },
  async decline(id, req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/${id}/decline`, req)
    return resp.data
  },
  async approve(id, req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/${id}/approve`, req)
    return resp.data
  },

  async getVisibleSignatureProfileImage(profileId) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/visibleSignature/profileImage/${profileId}`)

    return resp
  },

  async getVisibleSignatureUserVerificationImage() {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/visibleSignature/userVerificationImage`)

    return resp
  },

  async getVisibleSignature(profileId) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/visibleSignature/${profileId}`)

    return resp
  },

  async combineImage(req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/visibleSignature/combineImage`, req)
    return resp.data
  },
  async pmSign(req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/pmSign`, req)
    return resp.data
  },

  async setVisisigAdminProps(req) {
    const axios = await createAxios()
    await axios.put(`${PATH}/visibleSignature/adminProps`, req)
  },

  async getVisisigAdminProps() {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/visibleSignature/adminProps`)
    return resp
  }

}
